module.exports = __webpack_public_path__ + "img/managertips_xl.4d8caa7a.png";